<template>
  <div class="app-container">
    <el-button size="small" type="primary" @click="goBack">返回</el-button>
    <div style="padding-top: 10px"></div>
    <el-card>
      <el-form :model="adDetail" style="width: 60%;" ref="adBannerForm" v-loading="uploadLoading">
        <el-form-item
            label="图片标题"
            label-width="90px"
            prop="title"
        >
          <el-input v-model="adDetail.title"/>
        </el-form-item>
        <el-form-item label="选择图片" label-width="90px">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(adDetail.imageUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="90px" label="是否启用">
          <el-switch active-text="启用" inactive-text="未启用" v-model="adDetail.isEnable"></el-switch>
        </el-form-item>
        <el-form-item
            label="链接地址"
            label-width="90px"
            prop="linkUrl"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="adDetail.linkUrl"/>
        </el-form-item>
        <el-form-item
            label="允许时长"
            label-width="90px"
            prop="allowSeconds"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input-number v-model.number="adDetail.allowSeconds" placeholder="单位: 秒"/>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="updateAd">保存</el-button>
    </el-card>

  </div>

</template>

<script>
import {
  isVaild
} from "@/utils/validate";
import {
  getSlideImageBannerOne,
  updateSlideImageBanner
} from "@/api/CarouselManagement/CarouselManagement";
import {handleRes} from "@/utils/handleRes";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {deepClone} from "@/utils";

export default {
  name: "AppAdDetail",
  data() {
    return {
      bannersId: -1,
      adDetail: {},
      uploadCoverFile: null,
      uploadCoverFileURL: "",
      uploadLoading: false,
    }
  },
  created() {
    let queryId = this.$route.query.bannersId
    if (isVaild(queryId)) {
      this.bannersId = queryId
      this.getSlideImageBannerOne()
    }
  },
  methods: {
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    goBack() {
      this.$router.go(-1)
    },
    getSlideImageBannerOne() {
      getSlideImageBannerOne({
        bannersId: this.bannersId
      }).then(res => {
        handleRes(res, () => {
          this.adDetail = res.data
        })
      })
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    async updateAd() {

      this.$refs["adBannerForm"].validate(async (valid) => {
        if (valid) {
          this.uploadLoading = true;
          let savepathParamsRes = await getOSSUploadInfo({
            DataType: "28",
            ID: "0",
          });
          if (!isVaild(savepathParamsRes)) {
            this.uploadLoading = false;
            return;
          }
          let savePathParams = savepathParamsRes.resultData

          //上传封面
          if (isVaild(this.uploadCoverFile)) {
            // printObj(this.uploadCoverFile.raw)
            let timestamp = new Date().valueOf();

            let uploadRes;
            let fileName;
            if (isVaild(this.uploadCoverFile)) {
              fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
              // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
              uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
                type: this.uploadCoverFile.raw.type
              }), fileName)
            }
            if (uploadRes.status === 0) {
              this.adDetail.imageUrl = "/" + fileName
              // console.log(this.form.liveCover)
            } else {
              this.$message({
                type: "error",
                message: "上传失败"
              })
            }
            this.$refs.uploadCoverRef.clearFiles();
          }

          const params = deepClone(this.adDetail);
          params.linkType = 1
          updateSlideImageBanner(params).then((res) => {
            handleRes(res, () => {
              this.$message('更新成功')
              this.getSlideImageBannerOne()
              this.uploadLoading = false;
            })
          });
        }
      });
    }
  }
}
</script>

<style scoped>

</style>